import React from "react";
import { useDispatch, useStore } from "react-redux";
import { 
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
    // DOCUMENT_TYPE_ANNUAL_INFORMATION_RETURN,
    DOCUMENT_TYPE_CRIMINAL_RECORD, 
    DOCUMENT_TYPE_INSURANCE_CONTINURATION, 
    DOCUMENT_TYPE_INSURANCE_PROOF, 
    DOCUMENT_TYPE_SURETY_BONDS
} from "../../../../app/constants";
import { fullName, humanReadableDate } from "../../../../app/utils";
import { LineSeperator } from "../../../../components/RegularComponents";
import { addCurrentAgentSupportingDocument } from "../../../../redux/slice/additionalApplicationsSlice";
import { applicationTypeFromLicenceSubType, isAgencyTypeApplication, isRenewalTypeApplication } from "../../../../redux/slice/applicationsUtils";
import { saveBusinessLicenceApplicationData } from "../../../../redux/slice/businessLicenceApplicationSlice";
import { addAgencySupportingDocument } from "../../../../redux/slice/primaryAgencyApplicationSlice";
import { InformationDetailPanelSection } from "../InformationDetailPanelSection";
import { CommonAttachmentsTab } from "./CommonAttachmentsTab";

export const AIRCheckTab = (props) => {
    // const dispatch = useDispatch()
    // const {userAuth} = useStore().getState()

    /* 
    const onFileUpload = (fileObj) => {
        if(fileObj && Object.keys(fileObj).length > 0) { 
            const obj = {...fileObj, 
                documentType : DOCUMENT_TYPE_ANNUAL_INFORMATION_RETURN,
                createdDate: new Date().getTime(),
                createdBy : userAuth?.userData?.email ?? "",
                changeType : "SAVE"
            }
            const {applicationType, applicationMode} = props
            dispatch(addAgencySupportingDocument(obj))
            dispatch(
                saveBusinessLicenceApplicationData(applicationType, applicationMode)
              ).then(data => {
                  
              })
        }
    }
    */

    return (
        <div>
            <InformationDetailPanelSection
                header={"Has the AIR been submitted?"}
                value={props.appData?.isAIRSubmitted ? "Yes" : "No"}
            />
             <LineSeperator />
             {/*  Not neededfor AIR documents as per new requirements
            <CommonAttachmentsTab
                documentTypes={[DOCUMENT_TYPE_ANNUAL_INFORMATION_RETURN]}
                onFileUpload={onFileUpload}
                {...props}
            /> */}
        </div>
    )
}


export const CriminalRecordsCheckTab = (props) => {
    const dispatch = useDispatch()
    const {userAuth} = useStore().getState()
    const {applicationType, applicationMode} = props

    const onFileUpload = (fileObj) => {
        if(fileObj && Object.keys(fileObj).length > 0) {
            const obj = {
                ...fileObj, 
                documentType : DOCUMENT_TYPE_CRIMINAL_RECORD, 
                createdDate: new Date().getTime(),
                createdBy : userAuth?.userData?.email ?? "",
                changeType: "SAVE"
            }
            
            if(isAgencyTypeApplication(props.licenceApplication)) {
                dispatch(addAgencySupportingDocument(obj))
            } else {
                dispatch(addCurrentAgentSupportingDocument(obj)) 
            }
            
            dispatch(
                saveBusinessLicenceApplicationData(applicationType, applicationMode)
                ).then(data => {
                    //
                })
        }
    }

    const peopleList = props.appData.companyRjscDetails?.businessData?.peopleList ?? []

    const criminalRecordsDocs = props.licenceApplication.documents.map(doc => {
        if(doc.documentType === DOCUMENT_TYPE_CRIMINAL_RECORD && doc.entityId !== null) {
            const entity = peopleList.find(p => +p.entityId === +doc.entityId)
            if(entity) {
                return {
                    ...doc, 
                    entityName : `${fullName(entity)},(${entity.position})`,
                }
            }
        }
        
        return doc
    })

    const modifiedAppplicationData = Object.assign({}, props.licenceApplication, {documents : criminalRecordsDocs})

    return (
        <CommonAttachmentsTab 
            documentTypes={[DOCUMENT_TYPE_CRIMINAL_RECORD]} 
            onFileUpload = {onFileUpload}
            showEntityDetails={(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE || 
                                applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE || 
                                applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE)}
            peopleList={peopleList}
            {...props}
            licenceApplication = {modifiedAppplicationData}
        />
    )
}

export const InsuranceProofRecordsCheckTab = (props) => {
    const {appData} = props
    const dispatch = useDispatch()
    const {userAuth, primaryAgencyApplication} = useStore().getState()
    const isRenewal = isRenewalTypeApplication(primaryAgencyApplication.application)
    const applicationType = applicationTypeFromLicenceSubType(primaryAgencyApplication.application?.licencingSubType)

    const onFileUpload = (fileObj) => {
        if(fileObj && Object.keys(fileObj).length > 0) { 
            const obj = {...fileObj, 
                createdDate: new Date().getTime(),
                createdBy : userAuth?.userData?.email ?? "",
                changeType : "SAVE"
            }
            const {applicationType, applicationMode} = props
            dispatch(addAgencySupportingDocument(obj))
            dispatch(
                saveBusinessLicenceApplicationData(applicationType, applicationMode)
              ).then(data => {
                  
              })
        }
    }
    return (
        <>
            {isRenewal && 
            <div>
                <h3>Annual confirmation :</h3>
                <InformationDetailPanelSection 
                    header={(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) ? "Principal Broker :" : "Compliance Officer :"}
                    value={fullName(appData?.personData)} />
                <InformationDetailPanelSection 
                    header={"Date :"}
                    value={humanReadableDate(appData?.mraRenewalInsuranceConfirmationDate)} />
                <LineSeperator />
            </div>}
            <CommonAttachmentsTab 
                documentTypes={[
                    DOCUMENT_TYPE_INSURANCE_PROOF,
                    DOCUMENT_TYPE_INSURANCE_CONTINURATION
                ]}
                onFileUpload = {onFileUpload}
                {...props} 
            />
        </>
    )
}

export const SuretyBondDocumentTableTab = (props) => {
    const {appData} = props
    const dispatch = useDispatch()
    const {userAuth} = useStore().getState()

    const onFileUpload = (fileObj) => {
        if(fileObj && Object.keys(fileObj).length > 0) { 
            const obj = {...fileObj, 
                documentType : DOCUMENT_TYPE_SURETY_BONDS,
                createdDate: new Date().getTime(),
                createdBy : userAuth?.userData?.email ?? "",
                changeType : "SAVE"
            }
            const {applicationType, applicationMode} = props
            dispatch(addAgencySupportingDocument(obj))
            dispatch(
                saveBusinessLicenceApplicationData(applicationType, applicationMode)
              ).then(data => {
                  
              })
        }
    }
    return (
        <>
            <InformationDetailPanelSection 
                header={"Date original received"}
                value={humanReadableDate(appData?.confirmSuretyBond)} />
            <LineSeperator />
            <div className="topMarginLarge">
                <CommonAttachmentsTab 
                    documentTypes={[DOCUMENT_TYPE_SURETY_BONDS]} 
                    onFileUpload = {onFileUpload}
                    {...props} 
                />
            </div>
        </>
    )
}